//Object.defineProperty(exports, "__esModule", { value: true });
import Vue from 'vue';
import featuregrid from './featuregrid.vue';
import dgov2Popup from './dgov2Popup.vue';
import VuePortal from '@linusborg/vue-simple-portal';

Vue.use(VuePortal,
    {
        name: 'portal',
    });

const DEBUG = false;
const basename = (url) => String(url || '').split(/[\\/]/).pop();
// NOTE: we're thunking for the Vue component in it's own
// file. Might be more graceful way(?)
window.attachFeatureGrid = function (selector, opts) {
  const doAttach = () => {
    if (DEBUG) console.log("attachFeatureGrid", selector, opts);
    let hpl;
    // FOR TESTING different numbers of slides... use line below
    // opts.slides = opts.slides.slice(0,5); // !@#$!! DEV TEST HACK, COMMENT OUT!
    const slides = opts.slides;

    // Preprocessing on inputs
    // Do any cleanup of slides as delivered: some of this should move to server?
    // 1. No VIRIN, grab from useful url (!) (but I think this is what
    //    the server does in article to deliver virin)
    //      however, does not work for videos.

    // aspect ratio is string, turn to w/h float
    // supported formats "6:4", "6x4", "6/4" or "1.5" where 6,4 are floats
    let aspectRatio = 6/4; // default
    const arStr = opts.aspectRatio;
    if (arStr && typeof(arStr) === "string") {
        try {
            let arParts;
            if (arStr.indexOf(":") >= 0) {
                arParts = arStr.split(":");
            } else if (arStr.indexOf("x") >= 0){
                arParts = arStr.split("x");
            } else if (arStr.indexOf("/") >= 0){
                arParts = arStr.split("/");
            } else {
                // maybe it's a number
                const arVal = parseFloat(arStr);
                if (arVal && arVal > 0) {
                    arParts = [arVal, 1];
                }
            }
            if (DEBUG) console.log("arParts", arParts);
            if (arParts && arParts.length === 2) {
                const wide = parseFloat(arParts[0]);
                const high = parseFloat(arParts[1]);
                if (DEBUG) console.log("ratio", wide, high)
                if (wide > 0 && high > 0){
                    aspectRatio = wide/high;
                }
            }
        } catch(e) {
            throw e;
            // don't let parsing or other errors deter us
            // the default will persist if it was unparsable
        }
    }
    if (DEBUG) console.log("aspectRatio", aspectRatio);
    // the 1.05 factor tries to make sure the aspect ratio doesn't match the image
    // barely, which evokes tiny pixel-off errors. This might be a matter of
    // more closely following the use of Math.floor and Math.ciel.
    // I.e. without this factor, an image at native 1.4999 aspect ratio
    // fills width first not height when the component aspectRatio is at 1.5
    opts.aspectRatio = aspectRatio;


    // clean slides as needed, note all this can be moved to server eventually
    for (let slide of slides) {
        //grab virin from path, works if shared media image
        // (video not supported atm)
        if (!slide.isVideo)  {
            let virin = basename(slide.imageUrl);
            virin = virin.replace(/\.[^/.]+$/, "");
            slide.virin = virin;
        }

        // make link have host
        if (slide.link.indexOf('http') < 0) {
            let host = location.protocol
                         + '//'
                         +location.hostname
                         +(location.port ? ":"+location.port: '')
            if (slide.link[0] !== '/') {
                host += "/"
            }
            slide.shareUrl = host+slide.link;
        } else {
            slide.shareUrl = slide.link;
        }
        if (DEBUG) console.log("slide link", slide.link);
        if (DEBUG) console.log("slide shareUrl", slide.shareUrl);
    }
    //// end preprocessing on inputs
    ////////

    const gridshow = new Vue({
        el: selector,
        data: {
          options: opts,
          mediaAspectRatio: opts.aspectRatio ? opts.aspectRatio : 6/4, // 6/4 == 6:4 == w:h
          popupOpen:  false,
        },
        created: function () {
            window.addEventListener('resize', () => this.handleCurrentSize());
        },
        mounted: function () {
            if (DEBUG) console.log("m31: Top level options", opts);
            if (DEBUG) console.log("m31: first slide", JSON.stringify(opts.slides[0], null, 2));
            //this.$refs.popup.handleCurrentSize();
        },
        render: Vue.compile(`
            <div class="gridlayout-slideshow-main" >
                <dgov2-popup
                    v-if="popupOpen"
                    ref="popup"
                    :onClose="popupClose"
                    :media-aspect-ratio="mediaAspectRatio"
                    :options="options"/>
                <featuregrid
                    :options="options"
                    :aspect-ratio="mediaAspectRatio"
                    :clickCallback="handleClick"/>
            </div>
        `).render,
        components: {featuregrid, dgov2Popup},
        methods: {
            handleClick: function (event, data) {
                this.options.initialSlide = data.slideIndex;
                this.popupOpen = !this.popupOpen;
                if (DEBUG) console.log("m50: handleClick", this.popupOpen, event, data);
                this.$nextTick( () => {
                    if (DEBUG) console.log('m52: call popup handleCurrentSize')
                    this.$refs.popup.handleCurrentSize();
                })

            },
            handleCurrentSize: function () {
            //    this.popupOpen = false;
            },
            popupClose: function () {
                this.popupOpen = false;

                // This triggers the resize event in featuregrid. It is delayed to ensure 
                // that the popup is closed and the body is reset before the layout is calculated
                setTimeout(function () {
                    window.dispatchEvent(new Event('resize'));
                }, 100);
            },

        }
      });
  };

  const IMMEDIATE = true; // developer switch
  const DELAY = 1000; // used only if IMMEDIATE is false
  if (IMMEDIATE) { doAttach(); }
  else { setTimeout(doAttach, DELAY); }
}
export default {
  value:true,
}
